













































































import { AdminSiteManagementDefaultDevice, needsSerialNumber } from '@/constants/admin-site-management'
import { AdminSiteManagementDeviceTypes } from '@/constants/admin-site-management'

export default {
  props: {
    stageIndex: {
      type: Number,
      required: true,
    },
    site: {
      type: Object,
      required: true,
    },
    devices: {
      type: Array,
      required: true,
    },
  },

  data() {
    return {
      isInitialLoading: true,
      isSavingData: false,
    }
  },

  computed: {},

  mounted: async function(): Promise<void> {
    this.isInitialLoading = false
    this.emitValidStatus()
  },

  beforeUpdate: async function(): Promise<void> {
    this.emitValidStatus()
  },

  methods: {
    isValid() {
      // valid if all serial numbers are filled out
      let devicesNeedingSerialNumbers = this.devices.filter(d => needsSerialNumber(d.type))
      return devicesNeedingSerialNumbers.filter(d => d.units.filter(u => !u.serialNumber).length > 0).length == 0
    },
    emitValidStatus() {
      console.log('emitValidStatus(): ' + this.isValid())
      return this.$emit('stageIsValid', {
        stageIndex: this.stageIndex,
        isValid: this.isValid(),
      })
    },
    unitDesc(val: any): string {
      return `${val.unitDesc}`
    },
  },
}
